import { CameraOutlined } from "@ant-design/icons";

const PosturalExamHeader = ({ title }: { title: string }) => {
  return (
    <h2 className="header-section-title">
      <CameraOutlined rev={undefined} />
      <span style={{ marginLeft: "5px" }}>{title}</span>
    </h2>
  );
};

export default PosturalExamHeader;
